export default "__VITE_ASSET__CQI$oTgb__"